import { render, staticRenderFns } from "./alerts.vue?vue&type=template&id=7fca4066&scoped=true&"
import script from "./alerts.vue?vue&type=script&lang=ts&"
export * from "./alerts.vue?vue&type=script&lang=ts&"
import style0 from "./alerts.vue?vue&type=style&index=0&id=7fca4066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fca4066",
  null
  
)

component.options.__file = "alerts.vue"
export default component.exports